import { render, staticRenderFns } from "./ObjectCardMedia.vue?vue&type=template&id=e3123134&scoped=true&"
import script from "./ObjectCardMedia.vue?vue&type=script&lang=js&"
export * from "./ObjectCardMedia.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardMedia.vue?vue&type=style&index=0&id=e3123134&lang=sass&scoped=true&"
import style1 from "./ObjectCardMedia.vue?vue&type=style&index=1&id=e3123134&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3123134",
  null
  
)

export default component.exports